













































































import Broadcast, { BroadcastTemplate } from '@/types/Broadcast.interface'
import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
export default Vue.extend({
    props: {
        broadcast: {
            type: Object as PropType<Broadcast>,
            required: true
        },
        edited: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        editable: false,
        broadcastName: null
    }),
    mounted() {
        //  Set our broadcast name variable to the initial name on our broadcast
        this.broadcastName = this.broadcast.name
    },
    methods: {
        edit: debounce(function (): void {
            //  Check if we were currently editing
            const editing = this.editable

            //  Regardless, lets invert so we go to the opposite state
            this.editable = !this.editable

            //  If we were not, then we should focus our input
            if (!editing) {
                //  We add a slight delay to account for it becoming editable
                setTimeout(() => {
                    this.$refs.broadcastName.focus()
                }, 100)
            }
            //  Else, we need to tell the parent about our changes
            else {
                this.$emit('updateName', this.broadcastName)
            }
        }, 250),
        popBroadcastTips(): void {
            //  Open via intercom
            window.Intercom('showArticle', 4844566)
        },
        popBroadcast101(): void {
            //  Open via Intercom
            window.Intercom('showArticle', 7005104)
        },
        popTour(): void {
            //  Start an intercom tour
            window.Intercom('startTour', 453932)
        },
        popTemplateCenter(): void {
            //  Our width depends on screen size
            const width = this.$vuetify.breakpoint.xsOnly ? '500px' : '850px'

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'template-center',
                width: width,
                closeable: true,
                closeOnSubmit: true,
                callback: (template: BroadcastTemplate) => {
                    //  Set our current template in the store
                    this.$store.commit('broadcastsViewSelectedTemplateSet', template)

                    //  Tell our parent to update with this template
                    this.$emit('templateSelected', template)
                }
            })
        }
    },
    watch: {
        broadcast: {
            deep: true,
            handler() {
                //  Lets make sure our broadcast name is up to date
                this.broadcastName = this.broadcast.name
            }
        }
    }
})
